import React from "react";
import Title from "../FormElements/Title";
import { InputField } from "../FormElements/InputField";
import { InputSelect } from "../FormElements/InputSelect";
import FormTitle from "../FormElements/FormTitle";
import CardInfo from "../FormElements/CardInfo";
import Button from "../FormElements/Button";
import { via } from "../../Utils/constants";
import { validateOnlyDecimalNumbers, validateOnlyNumbers } from "../../Utils/validators";

interface StepPersonalDataProps {
  assured: any;
  serviceData: any[];
  register: any;
  objSendForm: any;
  afpData: any[];
  prestacionWatch: any;
  selectSalud: any;
  coverageData: any[];
  validationAverageProm: () => boolean | undefined;
  averageRenum: any;
  handleSubmit: any;
  nextActiveStep: (id: number) => void;
  setObjSendForm: (data: any) => void;
  disabledStepGeneral: () => boolean | undefined;
}

const StepPersonalData: React.FC<StepPersonalDataProps> = ({
  assured,
  serviceData,
  register,
  objSendForm,
  afpData,
  prestacionWatch,
  selectSalud,
  coverageData,
  validationAverageProm,
  averageRenum,
  handleSubmit,
  nextActiveStep,
  setObjSendForm,
  disabledStepGeneral,
}) => {
  return (
    <form
      style={{
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
      onSubmit={handleSubmit((value: any) => {
        nextActiveStep(1);
        setObjSendForm({ ...objSendForm, ...value });
      })}
    >
      <div>
        <FormTitle
          title="Ingresa los datos personales del contratante"
          parrafo="El contratante es la persona que es titular de la póliza y asegurado a la vez."
        />
        <div>
          <CardInfo
            client={{
              names:
                assured.names +
                " " +
                assured.firstName +
                " " +
                assured.lastName,
              fecNacimiento: assured.birthday,
              numDocumento: assured.nroDoc,
              sexo: assured.sexo,
              telefono: assured.phone,
              typeDoc: assured.typeDoc,
            }}
          />
          <Title title="Otros datos personales" />
          <div className="flex col gap-md">
            <InputSelect
              options={serviceData}
              placeHolder="Prestación"
              register={register}
              name="prestacion"
              id="service"
              defaultValue={objSendForm ? objSendForm.prestacion : ""}
            />
            <InputField
              placeHolder="CUSPP"
              name="cuspp"
              register={register}
              defaultValue={objSendForm ? objSendForm.cuspp : ""}
              maxLegth={12}
            />

            <InputSelect
              options={afpData}
              placeHolder="AFP"
              name="afp"
              register={register}
              disabled={!objSendForm && !prestacionWatch}
              defaultValue={objSendForm ? objSendForm.afp : ""}
            />
            <InputField
              disabled={true}
              name="salud"
              register={register}
              defaultValue={selectSalud && selectSalud}
              placeHolder="Salud"
            />
            <InputSelect
              options={coverageData}
              placeHolder="Cobertura"
              defaultValue={objSendForm ? objSendForm.coverage : ""}
              register={register}
              name="coverage"
              id="coverage"
              disabled={!objSendForm && !prestacionWatch}
            />
            <InputField
              defaultValue={
                objSendForm ? objSendForm.averageRenum : averageRenum
              }
              placeHolder="Remuneración prom"
              disabled={validationAverageProm()}
              register={register}
              name="averageRenum"
              validate={validateOnlyDecimalNumbers}
            />
          </div>
          <Title title="Datos de contacto" />
          <div className="flex col gap-md">
            <InputField
              defaultValue={objSendForm ? objSendForm.phone : ""}
              placeHolder="Teléfono de casa"
              register={register}
              name="phone"
              maxLegth={11}
              validate={validateOnlyNumbers}
            />
            <InputField
              defaultValue={objSendForm ? objSendForm.cellPhone : ""}
              placeHolder="Celular"
              register={register}
              name="cellPhone"
              maxLegth={9}
              validate={validateOnlyNumbers}
            />
            <InputField
              defaultValue={objSendForm ? objSendForm.email : ""}
              placeHolder="Correo electrónico"
              name="email"
              register={register}
            />
            <div className="clientForm__control__inputSelect mw-full">
              <select
                className={"browser-default"}
                name="typeAddress"
                ref={register}
                defaultValue={objSendForm ? objSendForm.typeAddress : ""}
              >
                <option value="" selected disabled>
                  Tipo de vía
                </option>
                {via.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.text}
                  </option>
                ))}
              </select>
              <div className={"clientForm__control input-field w-full"}>
                <input
                  name="address"
                  type="text"
                  id="address"
                  ref={register}
                  defaultValue={objSendForm ? objSendForm.address : ""}
                />
                <label
                  className={
                    objSendForm && objSendForm.address ? "active" : "false"
                  }
                  htmlFor="address.name"
                >
                  Dirección
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="button__container">
        <Button type="submit" disabled={disabledStepGeneral()}>
          Continuar
        </Button>
      </div>
    </form>
  );
};

export default StepPersonalData;
